export const DISRUPTION_HOME_ROUTE = `/`;

export const BASE_PATH_DISRUPTION =
  DISRUPTION_HOME_ROUTE + "disruption/exercise/:reservationId/";
export const PATH_DISRUPTION_EXERCISE = "/";
export const PATH_DISRUPTION_EXERCISE_REFUND =
  PATH_DISRUPTION_EXERCISE + "refund/";
